import { observer } from "mobx-react-lite";
// import { useRoutes } from "react-router-dom";
import "nprogress/nprogress.css";
import { AppRouter } from "./AppRouter";
import { DefaultLayout, ProvidersLayout } from "./components/Layouts/Layouts";

// import routesConfig from "./routesConfig";

declare global {
  interface Window {
    Telegram: WebApp;
  }
}

// const AppRoutes = observer(() => {
//   const routes = useRoutes(routesConfig);
//   return routes;
// });

const App = observer(() => {
  return (
    <ProvidersLayout>
      <DefaultLayout>
        <AppRouter />
      </DefaultLayout>
    </ProvidersLayout>
  );
});

export default App;
